import { ActionStepper, ActionStepperSize, MinimalistTitle } from '@wallyhealth/web-core'
import styles from './index.module.css'
import items from './items.json'

const Setup = () => (
  <div className={styles.container}>
      <MinimalistTitle
        className={styles.title}
        title="Setup"
      />
    <div className={styles.body}>
      <ActionStepper
        className={styles.steps}
        descriptionClassName={styles.description}
        stepperClassName={styles.stepper}
        items={items}
        size={ActionStepperSize.LARGE}
      />
    </div>
  </div>
)

export default Setup
